import React, { Component } from 'react';
import { Button, Col, Row, Container, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import toastr from '../toastr';
import { modal } from '../modal/ModalEmitter';
import { getUser } from '../../actions/AppActions';
import Api from '../../services/ApiService';
import Form from '../form/Form';
import config from '../../config';

class MFAView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasMfa: props.hasMfa,
      qrcodeDataUrl: '',
      secret: '',
    };

    this.enableMFA = this.enableMFA.bind(this);
    this.disableMFA = this.disableMFA.bind(this);
    this.verifyMFA = this.verifyMFA.bind(this);
  }

  enableMFA() {
    Api.post('auth/mfa/enable').then(({ data }) => {
      this.setState({ hasMfa: true, qrcodeDataUrl: data.qrcodeDataUrl, secret: data.secret });
    });
  }

  disableMFA() {
    modal.confirm({
      message: 'Removing multi-factor authentication can make your account less secure.',
      headerClass: 'primary',
      callback: () => {
        Api.post('auth/mfa/disable').then(() => {
          this.props.getUser();
          this.setState({ hasMfa: false, qrcodeDataUrl: '' });
        });
      },
    });
  }

  verifyMFA({ token }) {
    const { secret } = this.state;

    Api.post('auth/mfa/verify', { secret, token }).then(() => {
      this.setState({ hasMfa: true, qrcodeDataUrl: '' });
      this.props.getUser();
    }).catch((err) => {
      toastr.error('Error', err.message);
    });
  }

  renderQrCode() {
    const { qrcodeDataUrl, secret } = this.state;

    const layout = [{
      name: 'token',
      label: 'Verification Code',
    }];

    return (
      <Container fluid>
        <Row>
          <Col md={5} sm={6} className="text-center">
            <div className="form-paragraph">After installing the <strong>Google Authenticator</strong> app scan the QR code below and enter the verification code.</div>
            <div>
              <img src={config.publicUrl('img/google-auth-logo.png')} alt="Google Authenticator" style={{ height: '35px', margin: '10px' }} />

              <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener noreferrer">
                <img src={config.publicUrl('img/google-play-badge.png')} alt="Google Play" style={{ height: '35px', margin: '10px' }} />
              </a>
              <a href="https://itunes.apple.com/us/app/google-authenticator/id388497605" target="_blank" rel="noopener noreferrer">
                <img src={config.publicUrl('img/itunes-badge.svg')} alt="iTunes" style={{ height: '35px', margin: '10px' }} />
              </a>
            </div>
            <div className="form-paragraph">Secret Key: <small>{secret}</small></div>
            <img src={qrcodeDataUrl} alt="QRCode" id="qr-code" />
          </Col>
          <Col md={2} sm={6} xs={12}>
            <Form
              hideCancel
              exportFormat="object"
              layout={layout}
              submit={this.verifyMFA}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  renderEnableMfa() {
    return (
      <div>
        <div className="form-paragraph">Each time you sign in to your account, you will need your password and a verification code.</div>
        <Button onClick={this.enableMFA} variant="success" size="lg">Enable MFA</Button>
      </div>
    );
  }

  renderDisableMfa() {
    return (
      <div>
        <div className="form-paragraph">Multi-Factor Authentication is setup and enabled. To disable MFA, click below.</div>
        <Button onClick={this.disableMFA} variant="danger" size="lg">Disable MFA</Button>
      </div>
    );
  }

  render() {
    const { hasMfa, qrcodeDataUrl } = this.state;
    const { mfaRequired } = this.props;

    if (qrcodeDataUrl) {
      return this.renderQrCode();
    }

    return (
      <div>
        {mfaRequired &&
          <Alert variant="warning"><strong>Multi-factor authenication is required for your account</strong></Alert>
        }
        { hasMfa
          ? this.renderDisableMfa()
          : this.renderEnableMfa()
        }
      </div>
    );
  }
}

MFAView.propTypes = {
  getUser: PropTypes.func,
  hasMfa: PropTypes.bool,
  mfaRequired: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    hasMfa: state.app.user.mfaSecret,
    mfaRequired: state.app.mfaRequired,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getUser }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MFAView);
